import { computed } from 'vue'
import type { ContextStore } from 'src/layouts/core-layout/types'
import { useContextStore, useURLStore } from 'src/store'

export default function useTheHeaderSite() {
  // @ts-ignore
  const { context, urlLang }: ContextStore = useContextStore()
  const { reverseL10N } = useURLStore()

  const siteName = computed(() => String(context.request?.site?.name || ''))
  const townTranslit = computed(() => String(context.town?.translit || ''))
  const hasSearch = computed(() => Boolean(context.search))

  const isProdoctorov = computed(() => siteName.value.includes('prodoctorov'))
  const isProbolezny = computed(() => siteName.value === 'probolezny')
  const isProtabletky = computed(() => siteName.value === 'protabletky')
  const isConsult = computed(() => siteName.value === 'consult')

  const townSelectUrl = computed(() => (
    reverseL10N({
      name: 'town_mobile_select',
      args: {
        language: urlLang,
      },
    }) || ''
  ))

  return {
    context,
    siteName,
    townTranslit,
    hasSearch,
    isProdoctorov,
    isProbolezny,
    isProtabletky,
    isConsult,
    townSelectUrl,
  }
}
